import types from '../types/email'
import missingInfoTypes from '../types/missingInfo'
import {User as userTypes} from '../../../state/types'
import {Map} from 'immutable'

const initialRoot = Map({
  isSending: false,
  isUpdating: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case missingInfoTypes.NEXT_STEP:
      return state.merge(initialRoot)
    case userTypes.UPDATE_MISSING_INFO:
      return state.merge({
        isUpdating: true,
        error: '',
      })
    case userTypes.UPDATE_MISSING_INFO_SUCCESS:
      return state.merge({
        isUpdating: false,
        error: '',
      })
    case userTypes.UPDATE_MISSING_INFO_FAIL:
      return state.merge({
        isUpdating: false,
        error: action.payload.error,
      })
    case types.SEND_CONFIRMATION_EMAIL:
      return state.merge({
        isSending: true,
        error: '',
      })
    case types.SEND_CONFIRMATION_EMAIL_SUCCESS:
      return state.merge({
        isSending: false,
        error: '',
      })
    case types.SEND_CONFIRMATION_EMAIL_FAIL:
      return state.merge({
        isSending: false,
        error: action.payload.error,
      })
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/missingInfo/reducers/email.js